import Vue from "vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import Plugin from 'v-fit-columns';

Vue.use(Plugin);


Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");






// import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// // import VueCropper  from 'vue-cropper'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import VueTinymce from "@packy-tang/vue-tinymce"

// import 'babel-polyfill'
// import Es6Promise from 'es6-promise'
// Es6Promise.polyfill()





// Vue.use(ElementUI)

// Vue.use(VueCropper)

// Vue.use(VueTinymce)

// import Storage from 'vue-ls'
// let storageOptions={
//   namespace: 'pro__', // key prefix
//   name: 'ls', // name variable Vue.[ls] or this.[$ls],
//   storage: 'local', // storage name session, local, memory
// }
// Vue.use(Storage, storageOptions)


// Vue.prototype.msgSuccess = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "success" });
// }
// Vue.prototype.msgWarning = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "warning" });
// }
// Vue.prototype.msgError = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "error" });
// }
// Vue.prototype.msgInfo = function (msg) {
//   this.$message.info(msg);
// }

// Vue.config.productionTip = false

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

